// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Riiy","content":"styles_content__3WnY8","row":"styles_row__3QYXR","footer":"styles_footer__2fNjU","phraseLength":"styles_phraseLength__yhuOY"};